import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=d3f68002&scoped=true"
import script from "./Boutique.vue?vue&type=script&lang=js"
export * from "./Boutique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f68002",
  null
  
)

export default component.exports